import React, { useEffect, useState } from "react";
import { Card, Grid, makeStyles } from "@material-ui/core";
import Table from "../../components/Table";
import {
    Today,
    ViewWeek,
    DateRange,
    History as HistoryIcon,
} from "@material-ui/icons";
import { getDateTimeString } from "../../support/stringFormats";
import { DashboardWidget } from "../../components/DashboardWidget";
import { useEmailHistory, useEmailHistoryEmails } from "./emailAPI";

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        height: "100vh",
    },
    paper: {
        padding: theme.spacing(2),
        backgroundColor: theme.palette.background.secondary,
    },
    fullHeight: {
        height: "100%",
    },
    mainCard: {
        height: "60%",
    },
    infoCard: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.background.tertiary,
    },
    statItems: {
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
        textAlign: "center",
    },
    statList: {
        width: "100%",
        justify: "space-around",
        color: theme.palette.text.secondary,
        hr: {
            alginSelf: "stretch",
            height: "auto",
        },
        flexWrap: "nowrap",
    },
}));

const columns = [
    {
        name: "Created",
        selector: "createdAt",
        sortable: true,
        format: (row) => getDateTimeString(row.createdAt),
    },
    { name: "Loan Number", selector: "loanNumber", sortable: true },
    { name: "Message", selector: "message", sortable: true, grow: 2 },
    {
        name: "Recipient",
        selector: "recipient.email",
        sortable: true,
        wrap: true,
        grow: 2,
    },
    {
        name: "Sender",
        selector: "sender.email",
        sortable: true,
        grow: 2,
    },
];

const EmailHistory = () => {
    const classes = useStyles();
    const emails = useEmailHistory();
    const {data, refresh} = useEmailHistoryEmails()

    return (
        <Grid container spacing={3} className={classes.gridContainer}>
            <DashboardWidget
                items={[
                    {
                        title: "Emails Today",
                        detail: emails?.emailsToday || 0,
                        icon: <Today />,
                    },
                    {
                        title: "Emails This Week",
                        detail: emails?.emailsWeek || 0,
                        icon: <ViewWeek />,
                    },
                    {
                        title: "Emails This Month",
                        detail: emails?.emailsThisMonth || 0,
                        icon: <DateRange />,
                    },
                    {
                        title: "Emails This Year",
                        detail: emails?.emailsThisYear || 0,
                        icon: <HistoryIcon />,
                    },
                ]}
            />
            <Grid item sm={12}>
                <Card className={classes.paper}>
                    <Table
                        title="Document Emails"
                        columns={columns}
                        searchable
                        data={data}
                        refresh={refresh}
                        exportable
                    />
                </Card>
            </Grid>
        </Grid>
    );
};
export default EmailHistory;
